export const getLoggingLevelCookieName = () => {
  return `utiq_logging_level`;
};
